import React from 'react'
import { Card, CardGroup, Col, Row } from 'react-bootstrap'

const RoomBuilding = () => {
  return (
    <>
   <Card className='no-border rounded-0 architectural-modeling container'>
            <Card className='text-center no-border rounded-0'>
                <Card.Body>
                    <Card.Title className='architectural-modeling-title'> 居室と建造物のデジタルツイン </Card.Title>
                    <Card.Text className='architectural-modeling-text text-left'>
                    デジタルツインを活用する対象が機械である必要性はなく、空間であっても構いません。ホームオフィス、会議場、史跡、ショッピングセンターなど、さまざまな場所を3D体験にすることができます。 デジタルツインによって、世界中の人がキャンパスを見学したり、史跡を見たり、会議に参加したり、バーチャルショッピングを体験したり、博物館を見学したりすることができます。 私たちは、ネパール開発センターのバーチャルツアーをお客様に提供するために、オフィスとワークステーションの精密なデジタルツインを作成しました。これはマルチユーザーのVR体験として開発されているので、現地に行かなくても、オフィスでエンジニアやアーティストと会うことができます。                  
                    </Card.Text>
                    <Row>
                        <Col md={{span:8, offset:2}}>

                    <CardGroup className='amazon-books-cardgroup'>
                        <Row>
                            <Col md={{span:5, offset:0}}>
                                <Card className='no-border rounded-0 architectural-modeling-card'>
                                    <Card.Img className='room-building-images' src={"/assets/digital-twin/room-building/images/rb_001.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 現実世界のオフィス <br /> （参考写真）</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={{span:7, offset:0}}>
                                <Card className='no-border rounded-0 architectural-modeling-card'>
                                    <Card.Img className='room-building-images' src={"/assets/digital-twin/room-building/images/rb_001_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 仮想空間（VR）のオフィス <br /> （3Dモデルのレンダリング画像） </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CardGroup>

                    <CardGroup className='amazon-books-cardgroup mt-5'>
                        <Row>
                            <Col md={{span:5, offset:0}}>
                                <Card className='no-border rounded-0 architectural-modeling-card'>
                                    <Card.Img className='room-building-images' src={"/assets/digital-twin/room-building/images/rb_002.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 現実世界のオフィス <br /> （参考写真）</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={{span:7, offset:0}}>
                                <Card className='no-border rounded-0 architectural-modeling-card'>
                                    <Card.Img className='room-building-images' src={"/assets/digital-twin/room-building/images/rb_002_01.jpg"} />
                                    <Card.Body>
                                    <Card.Title className='architectural-modeling-footer-title'> 仮想空間（VR）のオフィス <br /> （3Dモデルのレンダリング画像） </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </CardGroup>

                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </Card>
      
    </>
  )
}

export default RoomBuilding
